'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var assetsIcons = exports.assetsIcons = {
  dropbox: require('assets/dropbox-icon.png'),
  boxcom: require('assets/boxcom-icon.png'),
  desktop: require('assets/desktop-icon.png')
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/cloud-config.js
// module id = 820
// module chunks = 1